import React, { useState } from "react";
import { RefCard, RangeIcon } from "../betTablePoker/refParts";
import { bookClass, isOpen, bySr, getExposureFrom } from "../betTablePoker/refUtils";
import { formatBook } from "../../../utils/formatOdds";

/**
 * Teenpatti Open (teen8) bet table in the reference admin's markup — rendered inside `.casino-detail`:
 *   .casino-box.mb-2.d-none-small >
 *     .casino-open-card-box (8 players' cards: cards[i], cards[i+9], cards[i+18])
 *     .casino-box-header (Player 1..8)
 *     .casino-box-content > 3 × .casino-box-row.mb-4 (Odds / Pair Plus / Total)
 * Markets like the reference: sub filtered by subtype Player / Pair / Total, ordered by sr.
 * Styled by the ported reference rules in styles/index.css (.teenpattiopen ...).
 */
export default function BetTableTeenPatti8({ data = [], cards = [], onBetClick, exposures = {} }) {
  const [openRange, setOpenRange] = useState({});
  const toggle = (id) => setOpenRange((s) => ({ ...s, [id]: !s[id] }));

  const sub = Array.isArray(data) ? data : [];
  const player = bySr(sub.filter((m) => m?.subtype === "Player"));
  const pair = bySr(sub.filter((m) => m?.subtype === "Pair"));
  const total = bySr(sub.filter((m) => m?.subtype === "Total"));

  const click = (m) => {
    if (!m || !isOpen(m)) return;
    onBetClick?.(m.b, m.nat, m);
  };

  const cell = (m, i, label, oddClass = "casino-box-odd") => {
    const exp = getExposureFrom(exposures, m?.nat);
    const suspended = !isOpen(m);
    return (
      <div
        key={m?.sid ?? i}
        className={`back casino-bl-box-item${suspended ? " suspended lock-top" : ""}`}
        onClick={() => click(m)}
      >
        <span className={oddClass}>{label}</span> <span className={`casino-book ${bookClass(exp)}`}>{formatBook(exp)}</span>
      </div>
    );
  };

  const row = (title, rangeId, list, render) => (
    <div className="casino-box-row mb-4">
      <div className="casino-nation-name">
        <b>{title}</b>{" "}
        <RangeIcon
          id={rangeId}
          market={list[0]}
          open={!!openRange[rangeId]}
          onToggle={toggle}
          iconClass="fas fa-info-circle float-right"
          attrOrder="target-first"
        />
      </div>{" "}
      <div className="casino-bl-box">{list.map(render)}</div>
    </div>
  );

  return (
    <div className="casino-box mb-2 d-none-small">
      <div className="casino-open-card-box">
        {player.map((p, i) => (
          <div key={p?.sid ?? i}>
            <div>
              <b>{i + 1}</b>
            </div>{" "}
            <div>
              <RefCard card={cards[i]} /> <RefCard card={cards[i + 9]} /> <RefCard card={cards[i + 18]} />
            </div>
          </div>
        ))}
      </div>{" "}
      <div className="casino-box-header">
        <div className="casino-nation-name no-border" />{" "}
        <div className="casino-bl-box text-right">
          {player.map((p, i) => (
            <div key={p?.sid ?? i} className="casino-bl-box-item">
              <span>{p?.nat}</span>
            </div>
          ))}
        </div>
      </div>{" "}
      <div className="casino-box-content">
        {row("Odds", "range1", player, (m, i) => cell(m, i, m?.b))}{" "}
        {row("Pair Plus", "range3", pair, (m, i) => cell(m, i, m?.nat, "casino-box-odd open-pair"))}{" "}
        {row("Total", "range2", total, (m, i) => cell(m, i, m?.b))}
      </div>
    </div>
  );
}
